import script from "./RegistroControlView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroControlView.vue?vue&type=script&setup=true&lang=js"

import "./RegistroControlView.vue?vue&type=style&index=0&id=ddf9894c&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddf9894c"]])

export default __exports__